/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ContinueWithVerificationUiFlow } from './continueWithVerificationUiFlow';


/**
 * Indicates, that the UI flow could be continued by showing a verification ui
 */
export interface ContinueWithVerificationUi { 
    /**
     * Action will always be `show_verification_ui` show_verification_ui ContinueWithActionShowVerificationUIString
     */
    action: ContinueWithVerificationUi.ActionEnum;
    flow: ContinueWithVerificationUiFlow;
}
export namespace ContinueWithVerificationUi {
    export type ActionEnum = 'show_verification_ui';
    export const ActionEnum = {
        ShowVerificationUi: 'show_verification_ui' as ActionEnum
    };
}


